export default { sha: 'a71adc33d8850245ef864febb7927bf3c60a93eb', buildNumber: 'undefined' }
